export { AssetDetails } from './asset-details';
